import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { useAppActions, useAppState } from '../../../overmind';
import { FetchType } from '../../../enums';
import { PagePath } from '../../../navigation/navigation.enums';
import { FreeTextContextPage } from './free-text-context.page';
import { WebSearchContextPage } from './web-search-context.page';
import { FileContextPage } from './file-context.page';
import { PageLoaderLayer } from '../../../components/general/loading-state/loader-layers/page-loader-layer/page-loader-layer';
import { useKeplerNavigate } from '../../../navigation/guards/use-kepler-navigate';

export function ContextPage(): JSX.Element {
  const { contextId } = useParams();
  const keplerNavigate = useKeplerNavigate();

  const actions = useAppActions();
  const { companyVariables } = useAppState();

  const [contextType, setContextType] = useState<string>();

  useEffect(() => {
    async function determineContextType() {
      if (!contextId) return keplerNavigate(`${PagePath.aiManagementBase}${PagePath.aiManagementContexts.replace(':companySlug', companyVariables.slug!)}`);

      actions.startLoader({ path: PagePath.aiManagementContext, type: FetchType.PageFetching });

      if (contextId === 'freetext' || contextId === 'websearch' || contextId === 'file') {
        setContextType(contextId);
        actions.stopLoader(PagePath.aiManagementContext);
        return;
      }

      const response = await actions.getContextById(contextId);
      if (!response) keplerNavigate(`${PagePath.aiManagementBase}${PagePath.aiManagementContexts.replace(':companySlug', companyVariables.slug!)}`);

      setContextType(response?.type.toLowerCase());
      actions.stopLoader(PagePath.aiManagementContext);
    }

    determineContextType();
  }, [contextId]);

  return <PageLoaderLayer path={PagePath.aiManagementContext}>{contextType === 'file' ? <FileContextPage /> : contextType === 'websearch' ? <WebSearchContextPage /> : <FreeTextContextPage />}</PageLoaderLayer>;
}
